import { render, staticRenderFns } from "./TodoReportCollectionUnit.vue?vue&type=template&id=e8b36a5e"
import script from "./TodoReportCollectionUnit.vue?vue&type=script&lang=js"
export * from "./TodoReportCollectionUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports